import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Building, Check, Shield, Droplets } from "lucide-react";
import React from "react";
import { useFacilitiesSummary } from "../../hooks"; // Adjust import path

export const DashboardCards: React.FC = () => {
  const { data: summaryData } = useFacilitiesSummary();

  // Use API data if available, otherwise fallback to defaults
  const totalFacilities = summaryData?.totalFacilities ?? 0;
  const operationalFacilities = summaryData?.operationalFacilities ?? 0;
  const averageConditionScore = summaryData?.averageConditionScore ?? 0;
  const totalCapacity = summaryData?.totalCapacityMld ?? 0;

  const metricCards = [
    {
      title: "Total Facilities",
      count: totalFacilities,
      trendSummary: "All registered facilities",
      icon: <Building className="h-8 w-8 text-blue-500" />,
      tooltip:
        "Total count of all registered facilities in the utility database, including operational, under maintenance, and decommissioned facilities.",
    },
    {
      title: "Operational",
      count: operationalFacilities,
      trendSummary: "Currently active facilities",
      icon: <Check className="h-8 w-8 text-green-500" />,
      tooltip:
        "Number of facilities currently in operational status, actively providing water treatment and distribution services.",
    },
    {
      title: "Avg Condition Score",
      count: averageConditionScore, // Round to 1 decimal
      trendSummary: "Overall facility health",
      icon: <Shield className="h-8 w-8 text-orange-500" />,
      tooltip:
        "Average condition score across all facilities, calculated as the mean of individual facility condition assessments (0-100 scale).",
    },
    {
      title: "Total Capacity",
      count: totalCapacity, // Round to 1 decimal
      trendSummary: "Combined design capacity (MLD)",
      icon: <Droplets className="h-8 w-8 text-blue-600" />,
      tooltip:
        "Total design capacity of all facilities combined, representing the maximum theoretical processing capacity of the utility's infrastructure.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
      {metricCards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          trendSummary={card.trendSummary}
          icon={card.icon}
          tooltip={card.tooltip}
        />
      ))}
    </div>
  );
};
